module.exports = __webpack_public_path__ + "static/BOOKING FORM MAIN HALL-5acd49e4e81af64fb17433ec2c0fe25a.pdf";